import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export default function FormDialog({
  open,
  title,
  subtitle,
  children,
  onClose,
  onSubmit,
  submitLabel = "Kaydet",
  cancelLabel = "İptal",
  loading = false,
  maxWidth = "sm",
  fullWidth = true,
  disableSubmit,
  actions = null,
  paperSx,
  titleSx,
  titleTextSx,
  subtitleTextSx,
  contentSx,
  actionsSx,
}) {
  return (
    <Dialog open={!!open} onClose={loading ? undefined : onClose} maxWidth={maxWidth} fullWidth={fullWidth} PaperProps={{ sx: paperSx }}>
      {(title || subtitle) && (
        <DialogTitle sx={titleSx}>
          <Stack spacing={0.5}>
            {title ? (
              <Typography variant="h6" sx={{ fontWeight: 800, ...titleTextSx }}>
                {title}
              </Typography>
            ) : null}
            {subtitle ? (
              <Typography variant="body2" color={subtitleTextSx ? undefined : "text.secondary"} sx={subtitleTextSx}>
                {subtitle}
              </Typography>
            ) : null}
          </Stack>
        </DialogTitle>
      )}

      <DialogContent dividers sx={contentSx}>{children}</DialogContent>

      {actions ? (
        <DialogActions sx={{ px: 3, py: 2, ...actionsSx }}>{actions}</DialogActions>
      ) : (
        <DialogActions sx={{ px: 3, py: 2, ...actionsSx }}>
          <Button onClick={onClose} color="inherit" disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            onClick={onSubmit}
            variant="contained"
            disabled={loading || !!disableSubmit}
            startIcon={loading ? <CircularProgress size={16} /> : null}
          >
            {submitLabel}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
